import type { SVGProps } from 'react';

const SvgInfoMarkLine = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill='none'
    height='1em'
    viewBox='0 0 24 24'
    width='1em'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10ZM12 17v-6'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={1.5}
    />
    <path d='M13 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z' fill='currentColor' />
  </svg>
);
export default SvgInfoMarkLine;
